<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'pedidos-proveedor' }">{{ $t("pedidoAProveedor") }}</router-link>
                        </li>
                        <li class="breadcrumb-item active">
                            {{ $t("propuestaDePedido") }}
                        </li>
                    </ol>
                </nav>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <div class="row">

                        <!--ALERTA-->
                        <div class="col-md-12" v-if="movedWarehouse > 0 && data.length !== 0">
                            <div class="alert alert-danger">
                                {{ $t("atencionHayMovimientosDeAlmacenQueNoSeHanDescargadoEnElNegocio") }}
                            </div>
                        </div>

                        <!--HACER PEDIDOS-->
                        <template v-if="!generarPedido && !idPedido">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label><strong>{{ $t("seleccionarNegocio") }}</strong></label>
                                    <el-select v-model="idsBusiness" multiple width="100%" filterable
                                        @change="getProveedores()" collapse-tags
                                        :placeholder="this.$i18n.t('seleccioneLosNegociosParaHacerelPedido')">
                                        <el-option v-for="n in listBusinesses" :key="n.id" :label="n.establishmentName"
                                            :value="n.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label><strong>{{ $t("seleccionarProveedor") }}</strong></label>
                                    <el-select class="select-default" v-model="idSupplier" filterable
                                        :placeholder="this.$i18n.t('noHayProveedoresEnEsteNegocio')">
                                        <el-option v-for="p in listProveedores" :key="p.id" :label="p.name"
                                            :value="p.name">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="col-md-3" style="margin-top: 10px">
                                <label> </label><br>
                                <div class="form-group">
                                    <el-checkbox v-model="pedidoBlanco">
                                        <strong>{{ $t("generarPedidoEnBlanco") }}</strong>
                                    </el-checkbox>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <label>&nbsp;</label>
                                <div class="form-group">
                                    <button @click="getOrder()" class="btn btn-primary">
                                        <i class="fas fa-share-square"></i>
                                        {{ $t("generarPedido") }}
                                        <i class="fa fa-refresh" v-if="loading"></i>
                                    </button>
                                </div>
                            </div>
                        </template>

                        <!--DETALLES DEL PEDIDO-->
                        <template v-if="generarPedido">
                            <div class="col-md-12">
                                <h4 class="text-center" style="margin-top: 0px">
                                    {{ $t("propuestaDePedido") }} <template
                                        v-if="idSupplier != 'Sin proveedor específico'">a {{ idSupplier }}</template>
                                </h4>
                            </div>
                            <div class="col-md-12" v-if="!idPedido || editar == 1">
                                <div class="form-group">
                                    <el-autocomplete v-model="idSubproduct" style="width: 100%" class="select-default"
                                        :fetch-suggestions="searchSubproductos"
                                        :placeholder="$t('buscarPorRefONombreDeLaMateriaPrima')"
                                        :trigger-on-focus="false" @select="getOrderSearchProduct">
                                        <template slot-scope="{ item }">
                                            <div class="value">{{ item.name }}</div>
                                        </template>
                                    </el-autocomplete>

                                    <!--<el-select-->
                                    <!--v-model="idSubproduct"-->
                                    <!--class="select-default"-->
                                    <!--filterable-->
                                    <!--remote-->
                                    <!--reserve-keyword-->
                                    <!--placeholder="Buscar por Ref. o Nombre de la matería prima"-->
                                    <!--:remote-method="searchSubproductos"-->
                                    <!--@change="getOrderSearchProduct()">-->
                                    <!--<el-option-->
                                    <!--v-for="p in listSubproduct"-->
                                    <!--:key="p.name"-->
                                    <!--:label="p.name"-->
                                    <!--:value="p.name">-->
                                    <!--</el-option>-->
                                    <!--</el-select>-->

                                    <el-checkbox v-model="buscarProveedor"
                                        :disabled="idSupplier == 'Sin proveedor específico'">
                                        <strong>{{ $t("buscarMateriaPrimaEnElMismoProveedor") }}</strong>
                                    </el-checkbox>
                                    <el-checkbox v-model="proveedoresMultiples" v-if="pedidoBlanco">
                                        <strong>{{$t("dividirPedidoEntreProveedores")}}</strong>
                                    </el-checkbox>
                                </div>
                            </div>
                            <div class="col-md-12" v-for="(d, indice) in data">
                                <div class="row">
                                    <div class="col-md-12" style="margin-bottom: 10px">
                                        <h5 class="wrapperNegocio">{{ d.nombreNegocio }}</h5>
                                    </div>
                                    <div class="col-md-12" style="margin-bottom: 10px">
                                        <div class="checkbox">
                                            <el-checkbox v-model="d.incluirIVA">
                                                <strong>{{ $t("precioIVAIncluido") }}</strong>
                                            </el-checkbox>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="table-responsive">
                                            <table class="table table-bordered table-striped">
                                                <thead class="thead-dark">
                                                    <tr>
                                                        <th rowspan="2">{{ $t("ref") }}.</th>
                                                        <th rowspan="2">{{ $t("nombre") }}</th>
                                                        <th rowspan="2">{{ $t("existencias") }}</th>
                                                        <th style="text-align: center; background-color: darkcyan; padding-bottom: 12px;"
                                                            colspan="2">{{ $t("pedido") }}
                                                        </th>
                                                        <th style="text-align: center; background-color: darkslategray; padding-bottom: 12px;"
                                                            colspan="3">{{ $t("precioArticuloUnidad") }}
                                                        </th>
                                                        <th style="text-align: center; background-color: darkolivegreen; padding-bottom: 12px;"
                                                            colspan="5">{{ $t("precioPedido") }}
                                                        </th>
                                                        <th rowspan="2">{{ $t("acciones") }}</th>
                                                    </tr>
                                                    <tr>
                                                        <th>{{ $t("uds") }}.</th>
                                                        <th>{{ $t("partes") }}</th>
                                                        <th>{{ $t("sinIVA") }}</th>
                                                        <th style="width: 7%">{{ $t("porcentajeIVA") }}</th>
                                                        <th>{{ $t("precioIVA") }}</th>
                                                        <th>{{ $t("base") }}</th>
                                                        <th style="width: 7%">{{ $t("porcentajeDto") }}</th>
                                                        <th>{{ $t("base") }}</th>
                                                        <th>{{ $t("cuotaIVA") }}</th>
                                                        <th>{{ $t("totalIVA") }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(s, index) in (d.subproduct || [])" :class="{ 'row-invalid-supplier': !idPedido && !s.nombreProveedor }">
                                                        <td>
                                                            <div>{{ s.cod_ean }}</div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                 <i v-if="!idPedido && !s.nombreProveedor"
                                                                     v-tooltip.top-center="$t('noTieneProveedor')"
                                                                     class="fas fa-exclamation-triangle text-warning"
                                                                     style="cursor: help; margin-left: 5px;">
                                                                 </i>
                                                                {{ s.name }}
                                                                <br>
                                                                 <span style="font-size:0.8em; color: #757272">
                                                                     ({{ $t("minimo") }}: {{ s.stockmin }}<template
                                                                         v-if="s.escandallo > 1 && s.stockminPartes > 0">/{{ s.stockminPartes }}</template>
                                                                     {{ s.type }}- {{ $t("optimo") }}: {{ s.stockop }}
                                                                     {{ s.type }}.</span><br>
                                                                 <span
                                                                     style="font-size:0.8em; color: #757272">{{ $t("escandallo") }}:
                                                                     {{ s.escandallo }})</span>
                                                             </div>
                                                             <template
                                                                 v-if="idSupplier == 'Sin proveedor específico'"><strong>{{ s.nombreProveedor }}</strong></template>
                                                         </td>
                                                        <td>
                                                            <div>{{ s.unidades }} / {{ s.partes }}</div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <input class="form-control" type="number"
                                                                    @blur="changeProduct(s, d)"
                                                                    v-model="s.unidadesPedido" placeholder="0" />
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <input class="form-control" type="number"
                                                                    :disabled="s.escandallo === 1"
                                                                    @blur="changeProduct(s, d)" v-model="s.partesPedido"
                                                                    placeholder="0" />
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <vue-numeric currency="€" class="form-control"
                                                                    inputmode="decimal" type="text"
                                                                    currency-symbol-position="suffix"
                                                                    :disabled="d.incluirIVA" :precision="4"
                                                                    @blur="changeProduct(s, d)"
                                                                    @keyup.native="changeProduct(s, d)"
                                                                    @keydown.native="$methods.evitarComasDecimales"
                                                                    v-model=s.sinIvaUnidad></vue-numeric>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <el-select @change="changeProduct(s, d)" v-model="s.iva"
                                                                    class="select-default">
                                                                    <el-option v-for="tax in taxList" :key="tax"
                                                                        :label="tax" :value="tax">
                                                                     
                                                                    </el-option>
                                                                </el-select>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <vue-numeric currency="€" class="form-control"
                                                                    inputmode="decimal" type="text"
                                                                    currency-symbol-position="suffix"
                                                                    :disabled="!d.incluirIVA" :precision="4"
                                                                    @blur="changeProduct(s, d)"
                                                                    @keyup.native="changeProduct(s, d)"
                                                                    @keydown.native="$methods.evitarComasDecimales"
                                                                    v-model=s.precioCompra>
                                                                </vue-numeric>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div style="white-space: nowrap;">{{ s.baseImp | currency }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <input class="form-control" type="number"
                                                                    v-model="s.dto" @blur="changeProduct(s, d)"
                                                                    @keydown="$methods.evitarComasDecimales"
                                                                    placeholder="0" />
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div style="white-space: nowrap;">{{ s.baseImpDto |
                                                                currency}}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div style="white-space: nowrap;">{{ s.cuotaIvaTotal |
                                                                currency }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div style="white-space: nowrap;">{{ s.ivaIncluidoTotal |
                                                                currency }}
                                                            </div>
                                                        </td>
                                                        <td align="center">
                                                            <i @click="eliminarProducto(index, indice)"
                                                                v-tooltip.top-center="$t('eliminarMateriaPrima')"
                                                                class="fas fa-minus-circle text-danger"
                                                                style="cursor: pointer"></i>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td></td>
                                                        <td>
                                                            <strong>TOTAL BASE</strong>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>
                                                            <div>{{ getBaseTotalSinDto(d) | currency }}</div>
                                                        </td>
                                                        <td></td>
                                                        <td>
                                                            <div>{{ d.amountTotal | currency }}</div>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>

                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <label><strong>{{ $t("observaciones") }}</strong></label>
                                            <input class="form-control" type="text" v-model="d.observaciones" />
                                        </div>
                                    </div>
                                    <div class="col-md-2 text-center">
                                        <div class="form-group">
                                            <p class="totalPedido">{{ $t("total") }}: <strong>{{ d.total |
                                                currency }}</strong></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 alert alert-danger"
                                v-if="data.length === 0 && !idPedido && generarPedido && !pedidoBlanco">
                                {{ $t("noHaySubproductosEnEsteNegocioParaRealizarElPedido") }}.
                                {{ $t("recuerdeQueParaQueAparezcanLosSubproductosDebenDeEstarAsociadosAUnProveedorYConfiguradosElStockMinimoYStockOptimo") }}
                            </div>
                            <div class="col-md-12"
                                v-if="data.length === 0 && !idPedido && generarPedido && !pedidoBlanco">
                                <router-link :to="{ name: 'pedidos-proveedor' }">
                                    <button class="btn btn-danger">
                                        <i class="fas fa-share-square"></i>
                                        {{ $t("volver") }}
                                        <i class="fa fa-refresh" v-if="loading"></i>
                                    </button>
                                </router-link>
                            </div>
                            <div v-if="generarPedido && data.length > 0" class="col-md-12">
                                <div class="form-group">
                            <button @click="savePedido" class="btn btn-success col-md-12" :disabled="loadingSave">
                                <i class="fas fa-share-square"></i>
                                {{ loadingSave ? $t("procesando") : $t("guardarPedido") }}
                                <i class="fa fa-refresh" v-if="loadingSave"></i>
                            </button>
                                </div>
                            </div>
                        </template>

                        <!--VISUALIZACION-->
                        <template v-if="idPedido && editar === 0">
                            <div class="col-md-12" v-if="pedido">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h5 class="wrapperNegocio">{{ pedido.nombreNegocio }}</h5>
                                    </div>

                                    <div class="col-md-12" v-if="pedido.observaciones !== ''">
                                        <div class="form-group">
                                            <label><strong>{{ $t("observaciones") }}</strong></label>
                                            {{ pedido.observaciones }}
                                        </div>
                                    </div>
                                    <!--<div class="col-md-12" style="margin-bottom: 10px">-->
                                    <!--<div class="checkbox">-->
                                    <!--<el-checkbox v-model="pedido.incluirIVA">-->
                                    <!--<strong>Precios IVA Incluído</strong>-->
                                    <!--</el-checkbox>-->
                                    <!--</div>-->
                                    <!--</div>-->

                                    <div class="col-md-12">
                                        <div class="table-responsive">
                                            <table class="table table-bordered table-striped">
                                                <thead class="thead-dark">
                                                    <tr>
                                                        <th rowspan="2">{{ $t("ref") }}.</th>
                                                        <th rowspan="2">
                                                            <span @click="toggleSort()">
                                                                <i v-if="sortState === 1" style="color: white" class="fa fa-angle-up"></i>
                                                                <i v-else-if="sortState === 2" style="color: white" class="fa fa-angle-down"></i>
                                                                {{ $t("nombre") }}
                                                            </span>
                                                        </th>
                                                        <th rowspan="2">{{ $t("existencias") }}</th>
                                                        <th style="text-align: center; background-color: darkcyan; padding-bottom: 12px;"
                                                            colspan="3">{{ $t("pedidos") }}
                                                        </th>
                                                        <th style="text-align: center; background-color: darkslategray; padding-bottom: 12px;"
                                                            colspan="3">{{ $t("precioArticuloUnidad") }}
                                                        </th>
                                                        <th style="text-align: center; background-color: darkolivegreen; padding-bottom: 12px;"
                                                            colspan="5">{{ $t("pedido") }}
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th>{{ $t("uds") }}.</th>
                                                        <th>{{ $t("tipo") }}.</th>
                                                        <th>{{ $t("partes") }}</th>
                                                        <th>{{ $t("sinIVA") }}</th>
                                                        <th>{{ $t("porcentajeIVA") }}</th>
                                                        <th>{{ $t("precioIVA") }}</th>
                                                        <th>{{ $t("base") }}</th>
                                                        <th>{{ $t("porcentajeDto") }}</th>
                                                        <th>{{ $t("baseTotal") }}</th>
                                                        <th>{{ $t("cuotaIVA") }}</th>
                                                        <th>{{ $t("totalIVA") }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(s) in sortedSubproducts">
                                                        <td>
                                                            <div>{{ s.cod_ean }}</div>
                                                        </td>
                                                        <td>
                                                            <div>{{ s.name }}<br>
                                                                <span
                                                                    style="font-size:0.9em; color: #757272">({{ $t("minimo") }}:
                                                                    {{ s.stockmin }}<template
                                                                        v-if="s.escandallo > 1 && s.stockminPartes > 0">/{{ s.stockminPartes }}</template>
                                                                    - {{ $t("optimo") }}: {{ s.stockop }}
                                                                    {{ s.type }}.)</span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>{{ s.unidades }} / {{ s.type }} / {{ s.partes }}</div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                {{ s.unidadesPedido }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                {{ s.type }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                {{ s.partesPedido }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                {{ s.sinIvaUnidad | currency }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                {{ s.taxRate }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                {{ s.precioCompra | currency }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>{{ s.baseImp | currency }}</div>
                                                        </td>
                                                        <td>
                                                            <div>{{ s.dto }}</div>
                                                        </td>
                                                        <td>
                                                            <div>{{ s.baseImpDto | currency }}</div>
                                                        </td>
                                                        <td>
                                                            <div>{{ s.cuotaIvaTotal | currency }}</div>
                                                        </td>
                                                        <td>
                                                            <div>{{ s.ivaIncluidoTotal | currency }}</div>
                                                        </td>
                                                    </tr>

                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td></td>
                                                        <td>
                                                            <strong>TOTAL BASE</strong>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>
                                                            <div>{{ getBaseTotalSinDto(pedido) | currency }}</div>
                                                        </td>
                                                        <td></td>
                                                        <td>
                                                            <div>{{ pedido.amountTotal | currency }}</div>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                    <div v-if="generarPedido" class="col-md-10">
                                        <p v-if="pedido.observaciones"><strong>{{ $t("observaciones") }}:</strong>
                                            {{ pedido.observaciones }}</p>
                                    </div>
                                    <div v-if="generarPedido" class="col-md-2 text-center">
                                        <p style="font-size: 1.4em">{{ $t("total") }}: <strong>{{ pedido.total |
                                            currency }}</strong>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <router-link :to="{ name: 'pedidos-proveedor' }">
                                    <button class="btn btn-danger">
                                        <i class="fas fa-undo-alt"></i>
                                        {{ $t("volver") }}
                                        <i class="fa fa-refresh" v-if="loading"></i>
                                    </button>
                                </router-link>
                            </div>
                        </template>
                        
                        <!--MODAL SELECCIONAR PROVEEDOR PARA MATERIAS PRIMAS SIN PROVEEDOR-->
                        <el-dialog
                            :title="$t('seleccionarProveedorMateriasPrimas')"
                            :visible.sync="showInvalidSupplierModal"
                            width="60%">
                            <div class="alert alert-warning">
                                <strong>{{ $t('lasSiguientesMateriasPrimasNoTienenProveedor') }}</strong>
                            </div>
                            <table class="table table-bordered table-striped">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>{{ $t('subproducto') }}</th>
                                        <th>{{ $t('negocio') }}</th>
                                        <th>{{ $t('proveedor') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, idx) in invalidSupplierList" :key="item.id">
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.nombreNegocio }}</td>
                                        <td>
                                            <el-select v-model="item.selectedSupplierId" filterable :placeholder="$t('seleccioneUnProveedor')" class="select-default" style="width: 100%;">
                                                <el-option
                                                    v-for="prov in listProveedores"
                                                    :key="prov.id"
                                                    :label="prov.name"
                                                    :value="prov.id">
                                                </el-option>
                                            </el-select>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <span slot="footer" class="dialog-footer">
                                <button @click="showInvalidSupplierModal = false" class="btn btn-danger btn-fill" :disabled="loadingSave">
                                    {{ $t('cancelar') }}
                                </button>
                                <button @click="confirmAssignSuppliers" class="btn btn-success btn-fill" :disabled="!allSuppliersSelected || loadingSave">
                                    {{ loadingSave ? $t('procesando') : $t('guardarYEnviar') }}
                                    <i class="fa fa-refresh" v-if="loadingSave"></i>
                                </button>
                            </span>
                        </el-dialog>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import swal from 'sweetalert2'
import moment from 'moment'
import {
    DatePicker,
    Select,
    Option,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Button,
    Checkbox,
    Switch,
    Autocomplete,
    Radio,
    Dialog
} from 'element-ui'
export default {
    name: "PedidoProveedorForm",
    props: ["idBusiness", "idPedido", "editar"],

    created() {

        if (this.idPedido) {
            this.getTaxRates();
            this.getOrderById();
            this.generarPedido = true;
        }
        else {
            this.getBusiness();
        }
    },
    computed: {
        getTotal() {
            let total = 0;
            let vm = this;
            this.data.forEach(function (d) {
                vm.total += d.ivaIncluidoTotal;
            });
            return vm.total;
        },
        sortedSubproducts() {
            if (!this.pedido.subproduct) return [];
            switch(this.sortState) {
                case 0: return this.pedido.subproduct;
                case 1: // asc
                    return [...this.pedido.subproduct].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
                case 2: // desc
                    return [...this.pedido.subproduct].sort((a, b) => b.name.toLowerCase().localeCompare(a.name.toLowerCase()));
                default: return this.pedido.subproduct;
            }
        },
        allSuppliersSelected() {
            if (!this.invalidSupplierList || this.invalidSupplierList.length === 0) return false;
            return this.invalidSupplierList.every(item => item.selectedSupplierId != null && item.selectedSupplierId !== '');
        },
    },
    data() {
        return {
            generarPedido: false,
            movedWarehouse: 0,

            idsBusiness: [],
            listBusinesses: [],
            listProveedores: [],
            idSupplier: "",
            oldIdSupplier: "",
            proveedoresMultiples: "",
            loading: false,

            taxList: [],
            data: [],
            incluirIVA: true,
            total: 0,
            observaciones: "",

            pedido: {},
            pedidoBlanco: false,

            listSubproduct: [],
            idSubproduct: "",

            buscarProveedor: true,
            taxRate: 0,
            defaultTaxRate: 0,
            sortState: 0, // 0: original, 1: asc, 2: desc
            ordenarNombre: true, // true for asc
            isSorted: false, // initially not sorted
            loadingSave: false,
            showInvalidSupplierModal: false,
            invalidSupplierList: [],
            
        }
    },
    watch: {
        idSupplier(val) {
            if (val == "Sin proveedor específico") {
                this.buscarProveedor = false;
            } else {
                this.buscarProveedor = true;
            }
        },
        proveedoresMultiples(val) {
            if (val) {
                this.idSupplier = "Sin proveedor específico";
            } else {
                this.idSupplier = this.oldIdSupplier;
            }
        }
    },
    methods: {
        toggleSort() {
            this.sortState = (this.sortState + 1) % 3;
        },
        
        getBaseTotal(data) {
            if (data && typeof data.baseTotal === 'number') {
                return data.baseTotal;
            }
            let total = 0;
            if (data && data.subproduct && Array.isArray(data.subproduct)) {
                data.subproduct.forEach(function (d) {
                    total += parseFloat(d.baseimponible || d.baseImp || 0);
                });
            }
            return total;
        },
        
        getBaseTotalSinDto(data) {
            if (data && typeof data.baseTotalSinDto === 'number') {
                return data.baseTotalSinDto;
            }
            let total = 0;
            if (data && data.subproduct && Array.isArray(data.subproduct)) {
                data.subproduct.forEach(function (d) {
                    total += parseFloat(d.baseTotalSinDto || d.baseImp || 0);
                });
            }
            return total;
        },
        getTaxRates() {
            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + 'taxes/getOnlyTaxes', config)
                .then(function (response) {
                    if (response.data.response) {
                        if (response.data.result) {
                            vm.taxList = response.data.result;
                            // console.log(vm.taxList);

                            // if (vm.taxList.length > 0) {
                            //     vm.taxRate = vm.taxList[0];
                            //     console.log("Valgo: " + vm.taxRate)
                            // }
                        }
                    } else {
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }
                });
        },
        getBusiness() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                .then(function (response) {
                    vm.listBusinesses = response.data.result;

                    if (vm.idBusiness) {
                        vm.idsBusiness.push(vm.idBusiness);
                    } else {
                        vm.idBusiness = response.data.result[0].id;
                        vm.idsBusiness.push(response.data.result[0].id);
                    }

                    vm.getTaxRates();

                    vm.getProveedores();
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getProveedores() {
            this.listProveedores = [];
            this.idSupplier = '';
            if (this.idsBusiness.length > 0) {
                const controller = 'getSuppliersByListBusiness';
                var config = {
                    params: {
                        pag: 0,
                        idsBusiness: this.idsBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
                };
                this.$store.dispatch("setIdBusiness", this.idBusiness);

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "suppliers/" + controller, config)
                    .then(function (response) {
                        if (response.data.response) {

                            /*vm.listProveedores.push({name: "Sin proveedor específico", id: -1});
                            vm.idSupplier = "Sin proveedor específico";*/
                            vm.idSupplier = response.data.result.suppliers[0].name
                            var mismoNombre = false;

                            for (let i = 0; i < response.data.result.suppliers.length; i++) {
                                mismoNombre = false;

                                for (let z = 0; z < vm.listProveedores.length; z++) {
                                    if (vm.listProveedores[z].name === response.data.result.suppliers[i].name) {
                                        mismoNombre = true
                                    }
                                }
                                if (!mismoNombre) {
                                    let proveedorname = {
                                        name: response.data.result.suppliers[i].name,
                                        id: response.data.result.suppliers[i].id,
                                    };

                                    vm.listProveedores.push(proveedorname)
                                }
                            }
                        }
                        else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        },
        
        changeProduct(product, cabe) {
            var baseImpSinDto;
            var baseImpDto;
            var totalconIva;
            var baseconIva;

            // console.log(product.precioCompra); 
            // console.log(product.iva); 

            // console.log(product.cuotaIvaUnidad);
            // console.log(product.sinIvaUnidad);

            // Calcular precio sin IVA
            // console.log('Antes de calcular precio sin IVA - product.precioCompra:', product.precioCompra, 'cabe.incluirIVA:', cabe.incluirIVA, 'ivaAnterior:', product.ivaAnterior || 'no definido');
            
            // Guardar el IVA anterior para detectar cambios
            var ivaAnterior = product.ivaAnterior || product.iva;
            
            if (cabe.incluirIVA) {
                // Si el IVA cambió, mantener el precio sin IVA constante y recalcular el precio con IVA
                if (ivaAnterior !== product.iva) {
                    // Mantener el precio sin IVA que ya teníamos
                    // product.sinIvaUnidad ya debería tener el valor correcto del cálculo anterior
                    // console.log('IVA cambiado de', ivaAnterior, 'a', product.iva, '- manteniendo sinIvaUnidad:', product.sinIvaUnidad);
                } else {
                    // Calcular el precio sin IVA normalmente
                    product.sinIvaUnidad = product.precioCompra / (1 + (product.iva / 100)); 
                }
                // Recalcular siempre el precio con IVA
                product.precioCompra = parseFloat(product.sinIvaUnidad) * (1 + product.iva / 100);
            } else {
                // Aplicar IVA si no está incluido
                product.precioCompra = parseFloat(product.sinIvaUnidad) * (1 + product.iva / 100);
            }
            
            // Guardar el IVA actual como anterior para la próxima vez
            product.ivaAnterior = product.iva;
            
            // console.log('Después de calcular precio sin IVA - product.sinIvaUnidad:', product.sinIvaUnidad, 'product.precioCompra:', product.precioCompra);

            // Calcular la cuota de IVA por unidad
            product.cuotaIvaUnidad = product.precioCompra - product.sinIvaUnidad;
            product.cuotaIvaTotal = product.cuotaIvaUnidad * product.unidadesPedido;

            // Calcular base imponible sin descuento
            baseImpSinDto = product.unidadesPedido * product.sinIvaUnidad;
            if (product.partesPedido !== 0) {
                baseImpSinDto += (product.partesPedido / product.escandallo) * product.sinIvaUnidad;
            }

            product.baseImp = baseImpSinDto;

            // Calcular base imponible con descuento
            baseImpDto = (product.sinIvaUnidad - (product.dto * product.sinIvaUnidad / 100)) * product.unidadesPedido;
            if (product.partesPedido !== 0) {
                baseImpDto += (product.partesPedido / product.escandallo) * (product.sinIvaUnidad - (product.dto * product.sinIvaUnidad / 100));
            }

            product.baseImpDto = baseImpDto;

            // Calcular el total con IVA incluido
            totalconIva = baseImpDto * (1 + (product.iva / 100));
            
            // Restar el valor anterior y sumar el nuevo
            // console.group('DEBUG changeProduct:');
            // console.log('  - product.iva:', product.iva);
            // console.log('  - product.unidadesPedido:', product.unidadesPedido);
            // console.log('  - product.sinIvaUnidad:', product.sinIvaUnidad);
            // console.log('  - product.dto:', product.dto);
            // console.log('  - baseImpDto:', baseImpDto);
            // console.log('  - totalconIva:', totalconIva);
            // console.log('Antes - cabe.total:', cabe.total, 'product.ivaIncluidoTotal:', product.ivaIncluidoTotal);
            // console.groupEnd();
            cabe.total = cabe.total - product.ivaIncluidoTotal + totalconIva;
            // console.log('Después - cabe.total:', cabe.total);
            product.ivaIncluidoTotal = totalconIva;
            
            // Actualizar amountTotal también
            cabe.amountTotal = cabe.total;
        },
        getOrderById() {
            // console.log(this.idPedido)
            const controller = 'getOrderById';
            var config = {
                params: {
                    pag: 0,
                    idPedido: this.idPedido,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            this.$store.dispatch("setIdBusiness", this.idBusiness);

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "orders/" + controller, config)
                .then(function (response) {
                    if (response.data.response) {
                        var ped = response.data.result.pedido;
                        var tax = ped.subproducts[0].iva;
                        var xSubpr = ped.subproducts;
                        var subproducs = [];

                        vm.idsBusiness.push(vm.idBusiness);

                        vm.idSupplier = ped.supplierName;

                        for (let i = 0; i < xSubpr.length; i++) {
                            let precioCompraSinIva = (parseFloat(xSubpr[i].price) / ((parseFloat(xSubpr[i].iva) / 100) + 1));

                            let cuotaIVAUnidad = xSubpr[i].price - precioCompraSinIva;
                            let cuotaTotal = cuotaIVAUnidad * xSubpr[i].unidadesPedido + xSubpr[i].partesPedido / xSubpr[i].escandallo;

                            // Para que sea seleccionado por defecto en el select
                            vm.taxRate = tax;

                            let xSub = {
                                id: xSubpr[i].id,
                                cod_ean: xSubpr[i].cod_ean,
                                name: xSubpr[i].name,
                                unidades: xSubpr[i].unidades,
                                partes: xSubpr[i].partes,
                                idTpv: xSubpr[i].idTpv,
                                idCasa: xSubpr[i].idCasa,
                                unidadesPedido: xSubpr[i].unidadesPedido,
                                partesPedido: xSubpr[i].partesPedido,
                                sinIvaUnidad: precioCompraSinIva,
                                cuotaIvaUnidad: cuotaIVAUnidad,
                                iva: xSubpr[i].iva,
                                baseImp: xSubpr[i].baseimponible,
                                dto: xSubpr[i].dto,
                                escandallo: xSubpr[i].escandallo,
                                precioCompra: xSubpr[i].price,
                                stockmin: xSubpr[i].stockmin,
                                stockminPartes: xSubpr[i].stockminpartes,
                                stockop: xSubpr[i].stockop,
                                type: xSubpr[i].type,
                                baseImpDto: xSubpr[i].amount,
                                cuotaIvaTotal: cuotaTotal,
                                ivaIncluidoTotal: xSubpr[i].total,
                                taxRate: xSubpr[i].iva || vm.defaultTaxRate
                            };

                            subproducs.push(xSub);
                        }

                        vm.pedido = {
                            nombreNegocio: ped.establishmentName,
                            incluirIVA: ped.ivaIncluded,
                            observaciones: ped.observaciones,
                            total: ped.totalPedido,
                            subproduct: subproducs,
                            amountTotal: ped.amountTotal
                        };

                        if (parseInt(vm.editar) === 1) {
                            vm.data.push(vm.pedido);
                        }

                        //console.log(vm.data);
                    }
                    else {
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getOrder() {
            if (this.idSupplier !== '') {
                if (!this.pedidoBlanco) {
                    const controller = 'getOrder';
                    var config = {
                        params: {
                            pag: 0,
                            idsBusiness: this.idsBusiness,
                            idSupplier: this.idSupplier,
                            jwt: this.$store.getters.jwt
                        },
                        headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
                    };
                    this.$store.dispatch("setIdBusiness", this.idBusiness);

                    let vm = this;
                    this.axios.get(this.$store.getters.apiUrl + "orders/" + controller, config)
                        .then(function (response) {
                            if (response.data.response) {
                                var subs = response.data.result.subproducts;
                                vm.movedWarehouse = response.data.result.almacen;

                                for (let i = 0; i < subs.length; i++) {
                                    var sub = [];
                                    var total = 0;

                                    if (subs[i].subproducts.length > 0) {
                                        for (let z = 0; z < subs[i].subproducts.length; z++) {
                                            var unidadesPedido = 0;
                                            var cuotaIVAUnidad = 0;
                                            var cuotaTotal = 0;
                                            var baseImp = 0;
                                            var precioCompraSinIva = 0;
                                            var baseImpDto = 0;
                                            var totalIVA = 0;

                                            if ((subs[i].subproducts[z].unidades * subs[i].subproducts[z].escandallo + subs[i].subproducts[z].partes) < subs[i].subproducts[z].stockmin * subs[i].subproducts[z].escandallo + subs[i].subproducts[z].stockminpartes) {
                                                if (subs[i].subproducts[z].unidades >= 0) {
                                                    unidadesPedido = subs[i].subproducts[z].stockop - subs[i].subproducts[z].unidades
                                                }
                                                else {
                                                    unidadesPedido = subs[i].subproducts[z].stockop;
                                                }
                                            }

                                            if (parseFloat(subs[i].subproducts[z].precioCompra) !== 0) {
                                                precioCompraSinIva = Math.round((parseFloat(subs[i].subproducts[z].precioCompra) / ((parseFloat(subs[i].subproducts[z].iva) / 100) + 1)) * 1000) / 1000;
                                                cuotaIVAUnidad = subs[i].subproducts[z].precioCompra - precioCompraSinIva;
                                                cuotaTotal = cuotaIVAUnidad * unidadesPedido;
                                                baseImpDto = (precioCompraSinIva - (subs[i].subproducts[z].dto * precioCompraSinIva / 100)) * unidadesPedido;
                                                baseImp = unidadesPedido * precioCompraSinIva;
                                            }
                                            totalIVA = (subs[i].subproducts[z].precioCompra - (subs[i].subproducts[z].dto * subs[i].subproducts[z].precioCompra / 100)) * unidadesPedido;

                                            total += totalIVA;

                                            let xSubp = {
                                                dto: subs[i].subproducts[z].dto,
                                                escandallo: subs[i].subproducts[z].escandallo,
                                                id: subs[i].subproducts[z].id,
                                                idCasa: subs[i].subproducts[z].idCasa,
                                                iva: subs[i].subproducts[z].iva,
                                                name: subs[i].subproducts[z].name,
                                                partes: subs[i].subproducts[z].partes,
                                                precioCompra: parseFloat(subs[i].subproducts[z].precioCompra),
                                                stockmin: subs[i].subproducts[z].stockmin,
                                                stockminPartes: subs[i].subproducts[z].stockminpartes,
                                                stockop: subs[i].subproducts[z].stockop,
                                                type: subs[i].subproducts[z].type,
                                                unidades: subs[i].subproducts[z].unidades,
                                                notaProveedor: "",
                                                cod_ean: subs[i].subproducts[z].cod_ean,
                                                unidadesPedido: unidadesPedido,
                                                partesPedido: 0,
                                                sinIvaUnidad: parseFloat(precioCompraSinIva),
                                                cuotaIvaUnidad: cuotaIVAUnidad,
                                                baseImp: baseImp,
                                                baseImpDto: baseImpDto,
                                                cuotaIvaTotal: cuotaTotal,
                                                ivaIncluidoTotal: totalIVA,
                                                idProveedor: subs[i].subproducts[z].idProveedor,
                                                nombreProveedor: subs[i].subproducts[z].nombreProveedor
                                            };

                                            sub.push(xSubp);
                                        }

                                        let xNegocio = {
                                            nombreNegocio: subs[i].nameNegocio.establishmentName,
                                            idNegocio: subs[i].idNegocio,
                                            incluirIVA: false,
                                            observaciones: "",
                                            total: total,
                                            subproduct: sub
                                        };

                                        vm.data.push(xNegocio);
                                    }
                                }

                                vm.generarPedido = true;
                            }
                            else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
                else {
                    this.generarPedido = true;
                    this.oldIdSupplier = this.idSupplier;
                    //this.idSupplier = "Sin proveedor específico";

                }
            }
            else {
                swal({
                    title: this.$t('atencion'),
                    text: this.$t('necesitasSeleccionarUnProveedorParaPoderHacerUnPedido'),
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });
            }
        },
        getOrderSearchProduct(idSubpoduct) {
            if (this.idSupplier !== '') {
                this.idSubproduct = idSubpoduct.name;

                const controller = 'getOrderByProduct';
                var config = {
                    params: {
                        pag: 0,
                        idsBusiness: this.idsBusiness,
                        idSubproduct: this.idSubproduct,
                        idSupplier: this.idSupplier,
                        jwt: this.$store.getters.jwt
                    },
                    headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
                };
                this.$store.dispatch("setIdBusiness", this.idBusiness);

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "orders/" + controller, config)
                    .then(function (response) {
                        if (response.data.response) {
                            var subs = response.data.result.subproducts;
                            vm.movedWarehouse = response.data.result.almacen;

                            if (vm.data.length === 0) {
                                for (let i = 0; i < subs.length; i++) {
                                    var unidadesPedido = 0;
                                    var cuotaIVAUnidad = 0;
                                    var cuotaTotal = 0;
                                    var baseImp = 0;
                                    var precioCompraSinIva = 0;
                                    var baseImpDto = 0;
                                    var totalIVA = 0;
                                    var sub = [];
                                    var total = 0;

                                    if (subs[i].subproducts.length > 0) {
                                        for (let z = 0; z < subs[i].subproducts.length; z++) {
                                            var unidadesReales = (subs[i].subproducts[z].unidades - (subs[i].subproducts[z].unidades % subs[i].subproducts[z].escandallo)) / subs[i].subproducts[z].escandallo;

                                            if ((subs[i].subproducts[z].unidades * subs[i].subproducts[z].escandallo + subs[i].subproducts[z].partes) < subs[i].subproducts[z].stockmin * subs[i].subproducts[z].escandallo + subs[i].subproducts[z].stockminpartes) {
                                                if (subs[i].subproducts[z].unidades >= 0) {
                                                    unidadesPedido = subs[i].subproducts[z].stockop - subs[i].subproducts[z].unidades
                                                }
                                                else {
                                                    unidadesPedido = subs[i].subproducts[z].stockop;
                                                }
                                            }

                                            if (parseFloat(subs[i].subproducts[z].precioCompra) !== 0) {
                                                precioCompraSinIva = Math.round((parseFloat(subs[i].subproducts[z].precioCompra) / ((parseFloat(subs[i].subproducts[z].iva) / 100) + 1)) * 1000) / 1000;
                                                cuotaIVAUnidad = subs[i].subproducts[z].precioCompra - precioCompraSinIva;
                                                cuotaTotal = cuotaIVAUnidad * unidadesPedido;
                                                baseImpDto = (precioCompraSinIva - (subs[i].subproducts[z].dto * precioCompraSinIva / 100)) * unidadesPedido;
                                                baseImp = unidadesPedido * precioCompraSinIva;
                                            }

                                            totalIVA = (subs[i].subproducts[z].precioCompra - (subs[i].subproducts[z].dto * subs[i].subproducts[z].precioCompra / 100)) * unidadesPedido;
                                            total += totalIVA;

                                            let xSubp = {
                                                dto: subs[i].subproducts[z].dto,
                                                escandallo: subs[i].subproducts[z].escandallo,
                                                id: subs[i].subproducts[z].id,
                                                idCasa: subs[i].subproducts[z].idCasa,
                                                iva: subs[i].subproducts[z].iva,
                                                idTpv: subs[i].subproducts[z].idTpv,
                                                name: subs[i].subproducts[z].name,
                                                partes: subs[i].subproducts[z].partes,
                                                precioCompra: parseFloat(subs[i].subproducts[z].precioCompra),
                                                stockmin: subs[i].subproducts[z].stockmin,
                                                stockminPartes: subs[i].subproducts[z].stockminpartes,
                                                stockop: subs[i].subproducts[z].stockop,
                                                type: subs[i].subproducts[z].type,
                                                unidades: subs[i].subproducts[z].unidades,
                                                notaProveedor: "",
                                                cod_ean: subs[i].subproducts[z].cod_ean,
                                                unidadesPedido: unidadesPedido,
                                                partesPedido: 0,
                                                sinIvaUnidad: parseFloat(precioCompraSinIva),
                                                cuotaIvaUnidad: cuotaIVAUnidad,
                                                baseImp: baseImp,
                                                baseImpDto: baseImpDto,
                                                cuotaIvaTotal: cuotaTotal,
                                                ivaIncluidoTotal: totalIVA,
                                                idProveedor: subs[i].subproducts[z].idProveedor,
                                                nombreProveedor: subs[i].subproducts[z].nombreProveedor
                                            };

                                            sub.push(xSubp);
                                        }

                                        let xNegocio = {
                                            nombreNegocio: subs[i].nameNegocio.establishmentName,
                                            idNegocio: subs[i].idNegocio,
                                            incluirIVA: true,
                                            observaciones: "",
                                            total: total,
                                            subproduct: sub
                                        };

                                        vm.data.push(xNegocio);
                                    }
                                }
                            } else {
                                var existe = false;

                                for (let i = 0; i < subs.length; i++) {
                                    for (let y = 0; y < vm.data.length; y++) {
                                        var unidadesPedido = 0;
                                        var cuotaIVAUnidad = 0;
                                        var cuotaTotal = 0;
                                        var baseImp = 0;
                                        var precioCompraSinIva = 0;
                                        var baseImpDto = 0;
                                        var totalIVA = 0;
                                        var sub = [];
                                        var total = 0;

                                        if (subs[i].nameNegocio.establishmentName === vm.data[y].nombreNegocio) {
                                            //FUNCIONA BIEN POR AQUI
                                            if ((subs[i].subproducts[0].unidades * subs[i].subproducts[0].escandallo + subs[i].subproducts[0].partes) < subs[i].subproducts[0].stockmin * subs[i].subproducts[0].escandallo + subs[i].subproducts[0].stockminpartes) {
                                                if (subs[i].subproducts[0].unidades >= 0) {
                                                    unidadesPedido = subs[i].subproducts[0].stockop - subs[i].subproducts[0].unidades
                                                }
                                                else {
                                                    unidadesPedido = subs[i].subproducts[0].stockop;
                                                }
                                            }

                                            if (parseFloat(subs[i].subproducts[0].precioCompra) !== 0) {
                                                precioCompraSinIva = Math.round((parseFloat(subs[i].subproducts[0].precioCompra) / ((parseFloat(subs[i].subproducts[0].iva) / 100) + 1)) * 1000) / 1000;
                                                cuotaIVAUnidad = subs[i].subproducts[0].precioCompra - precioCompraSinIva;
                                                cuotaTotal = cuotaIVAUnidad * unidadesPedido;
                                                baseImpDto = (precioCompraSinIva - (subs[i].subproducts[0].dto * precioCompraSinIva / 100)) * unidadesPedido;
                                                baseImp = unidadesPedido * precioCompraSinIva;
                                            }

                                            totalIVA = (subs[i].subproducts[0].precioCompra - (subs[i].subproducts[0].dto * subs[i].subproducts[0].precioCompra / 100)) * unidadesPedido;

                                            let xSubp = {
                                                dto: subs[i].subproducts[0].dto,
                                                escandallo: subs[i].subproducts[0].escandallo,
                                                id: subs[i].subproducts[0].id,
                                                idCasa: subs[i].subproducts[0].idCasa,
                                                iva: subs[i].subproducts[0].iva,
                                                name: subs[i].subproducts[0].name,
                                                idTpv: subs[i].subproducts[0].idTpv,
                                                partes: subs[i].subproducts[0].partes,
                                                precioCompra: parseFloat(subs[i].subproducts[0].precioCompra),
                                                stockmin: subs[i].subproducts[0].stockmin,
                                                stockminPartes: subs[i].subproducts[0].stockminpartes,
                                                stockop: subs[i].subproducts[0].stockop,
                                                type: subs[i].subproducts[0].type,
                                                unidades: subs[i].subproducts[0].unidades,
                                                notaProveedor: "",
                                                cod_ean: subs[i].subproducts[0].cod_ean,
                                                unidadesPedido: unidadesPedido,
                                                partesPedido: 0,
                                                sinIvaUnidad: parseFloat(precioCompraSinIva),
                                                cuotaIvaUnidad: cuotaIVAUnidad,
                                                baseImp: baseImp,
                                                baseImpDto: baseImpDto,
                                                cuotaIvaTotal: cuotaTotal,
                                                ivaIncluidoTotal: totalIVA,
                                                idProveedor: subs[i].subproducts[0].idProveedor,
                                                nombreProveedor: subs[i].subproducts[0].nombreProveedor
                                            };

                                            vm.data[y].subproduct.push(xSubp);
                                            vm.data[y].total = vm.data[y].total + totalIVA;
                                        }
                                    }
                                }
                            }

                            vm.generarPedido = true;
                        }
                        else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
            else {
                swal({
                    title: this.$t('atencion'),
                    text: this.$t('necesitasSeleccionarUnProveedorParaPoderHacerUnPedido'),
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });
            }
        },
        checkCampos() {
            let error = false;
            let vm = this;
            this.data.forEach(function (d) {
                if (d && d.subproduct && Array.isArray(d.subproduct)) {
                    d.subproduct.forEach(function (e) {
                        if (e.unidadesPedido === 0 && e.partesPedido === 0) {
                            error = true;
                        }
                    });
                }
            });

            return error;
        },
        confirmAssignSuppliers() {
            let vm = this;
            this.loadingSave = true;

            // Mapeo de idSubproduct -> idSupplier seleccionado
            var assignments = this.invalidSupplierList.map(function (item) {
                return {
                    idSubproduct: item.id,
                    idSupplier: item.selectedSupplierId
                };
            });

            // Lanzar peticiones al backend para actualizar proveedores
            var promises = assignments.map(function (assignment) {
                var config = {
                    params: {
                        jwt: vm.$store.getters.jwt
                    },
                    headers: { 'Authorization': "Bearer " + vm.$store.getters.jwt }
                };
                return vm.axios.post(vm.$store.getters.apiUrl + 'subproducts/editSubproductSupplier', assignment, config)
                    .then(function (response) {
                        return { success: true, assignment: assignment };
                    })
                    .catch(function (error) {
                        return { 
                            success: false, 
                            assignment: assignment, 
                            message: error.response && error.response.data && error.response.data.message ? error.response.data.message : vm.$t('errorAlActualizarProveedor')
                        };
                    });
            });

            Promise.all(promises)
                .then(function (results) {
                    var errors = results.filter(function (r) { return !r.success; });
                    
                    if (errors.length > 0) {
                        vm.showInvalidSupplierModal = false;
                        vm.loadingSave = false;
                        var errorMsg = errors.map(function (e) {
                            return e.message;
                        }).join('\n');
                        swal({
                            title: vm.$t('atencion'),
                            text: errorMsg,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    } else {
                        // Asignar proveedores seleccionados a los subproductos en data
                        assignments.forEach(function (assignment) {
                            var selectedProv = vm.listProveedores.find(function (p) {
                                return p.id === assignment.idSupplier;
                            });
                            if (selectedProv) {
                                vm.data.forEach(function (d) {
                                    if (d && d.subproduct && Array.isArray(d.subproduct)) {
                                        d.subproduct.forEach(function (s) {
                                            if (s.id === assignment.idSubproduct) {
                                                s.idProveedor = selectedProv.id;
                                                s.nombreProveedor = selectedProv.name;
                                            }
                                        });
                                    }
                                });
                            }
                        });
                        vm.showInvalidSupplierModal = false;
                        vm.savePedido();
                    }
                })
                .catch(function (error) {
                    vm.loadingSave = false;
                    swal({
                        title: vm.$t('atencion'),
                        text: vm.$t('errorAlActualizarProveedor'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                });
        },
        savePedido() {
            let hasZeroUnits = false;

            // Comprobar si hay alguna materia prima con 0 unidades y 0 partes
            this.data.forEach(d => {
                if (d && d.subproduct && Array.isArray(d.subproduct)) {
                    d.subproduct.forEach(s => {
                        let uds = Number(s.unidadesPedido) || 0;
                        let partes = Number(s.partesPedido) || 0;
                        if (uds === 0 && partes === 0) {
                            hasZeroUnits = true;
                        }
                    });
                }
            });

            if (hasZeroUnits) {
                swal({
                    title: this.$t("atencion") || "Atención",
                    text: this.$t("modalTextMp0") || "Tienes materias primas con uds y partes a 0. ¿Quieres excluirlas del pedido?",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    confirmButtonText: this.$t("excluir") || 'Excluir',
                    cancelButtonText: this.$t("cancelar") || "Cancelar",
                    buttonsStyling: true
                }).then((result) => {
                    if (result.value) {
                        // eliminar las materias primas con 0 del array
                        this.data.forEach(d => {
                            if (d && d.subproduct && Array.isArray(d.subproduct)) {
                                d.subproduct = d.subproduct.filter(s => {
                                    let uds = Number(s.unidadesPedido) || 0;
                                    let partes = Number(s.partesPedido) || 0;
                                    return !(uds === 0 && partes === 0);
                                });
                            }
                        });

                        // Eliminar los negocios que se hayan quedado sin subproductos tras el filtro
                        this.data = this.data.filter(d => d.subproduct.length > 0);

                        // Comprobar si el pedido se ha quedado completamente vacío
                        if (this.data.length === 0) {
                             swal({
                                title: this.$t("atencion") || "Atención",
                                text: this.$t("pedidoSinMp") || "El pedido se ha quedado vacío tras excluir las materias primas.",
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                            return;
                        }

                        
                        this.executeSavePedido();
                    }
                });
            } else {
                
                this.executeSavePedido();
            }
        },
        executeSavePedido() {
            let invalidProducts = [];

            // Esto SOLO es aplicable para pedidos nuevos
            if (!this.idPedido) {
                this.data.forEach(function (d) {
                    if (d && d.subproduct && Array.isArray(d.subproduct)) {
                        d.subproduct.forEach(function (s) {
                            if (!s.nombreProveedor) {
                                invalidProducts.push({
                                    id: s.id,
                                    name: s.name,
                                    nombreNegocio: d.nombreNegocio,
                                    selectedSupplierId: null
                                });
                            }
                        });
                    }
                });
            }

            if (invalidProducts.length > 0) {
                this.invalidSupplierList = invalidProducts;
                this.showInvalidSupplierModal = true;
                this.loadingSave = false;
                return;
            }

            this.loadingSave = true;
            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            var params = {
                idSupplier: this.idSupplier == "Sin proveedor específico" ? -1 : this.idSupplier,
                idsBusiness: this.idsBusiness,
                subproducts: this.data,
                jwt: this.$store.getters.jwt,
                idPedido: this.idPedido,
            };

            let vm = this;
            let controller = this.idPedido ? "editOrder" : "saveOrder";
            // console.log(params);
            this.axios.post(this.$store.getters.apiUrl + 'orders/' + controller, params, config)
                .then(function (response) {
                    vm.loadingSave = false;
                    if (response.data.response) {
                        let notify = vm.idPedido ? vm.$t('actualizado') : vm.$t('creado');
                        vm.$notify({
                            message: vm.$t('pedido') + ' ' + notify + ' ' + vm.$t('correctamente'),
                            icon: 'nc-icon nc-check-2',
                            timeout: 2000,
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'success'
                        });

                        vm.$router.push({
                            name: 'pedidos-proveedor',
                            params: { idBusiness: vm.idBusiness }
                        })
                    } else {
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }
                }).catch(function (error) {
                    console.log(error);
                    vm.loadingSave = false;
                });
        },
        eliminarProducto(index, indiceCab) {
            this.data[indiceCab].total = this.data[indiceCab].total - this.data[indiceCab].subproduct[index].ivaIncluidoTotal
            this.data[indiceCab].subproduct.splice(index, 1);

            if (this.data[indiceCab].subproduct.length > 0) {

            } else {
                this.data.splice(indiceCab, 1)
            }

            if (this.data.length > 0) {

            } else {
                swal({
                    title: this.$t('estePedidoNoEsValido'),
                    text: this.$t('quieresRestablecerElPedido'),
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    confirmButtonText: this.$t('siRestablecerPedido'),
                    cancelButtonText: this.$t('cancelar'),
                    buttonsStyling: true
                }).then((result) => {
                    if (result.value) {
                        this.getOrder();
                    }
                    else {
                        this.$router.push({ name: 'pedidos-proveedor' });
                    }
                })
            }
        },
        searchSubproductos(query, cb) {
            if (query !== '') {
                const controller = 'searchSubproductsByPedidosProveedores/' + query;
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt,
                        buscarProveedor: this.buscarProveedor,
                        idsBusiness: this.idsBusiness,
                        idSupplier: this.idSupplier,
                    },
                    headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "subproducts/" + controller, config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.listSubproduct = response.data.result;
                            cb(vm.listSubproduct);
                        }
                        else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        }
    },
    components: {
        [Checkbox.name]: Checkbox,
        [Switch.name]: Switch,
        [DatePicker.name]: DatePicker,
        [Select.name]: Select,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Option.name]: Option,
        [Radio.name]: Radio,
        [Autocomplete.name]: Autocomplete,
        [Dialog.name]: Dialog
    },
}
</script>
<style scoped>
.card {
    padding: 20px;
}

#layoutTipoDocumento {
    margin-top: 5px;
    margin-left: 5px;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
    background-color: #cdcdcd !important;
}

.el-select-dropdown__item {
    color: #111;
}

.bg-add-subproduct {
    background-color: #1E22AA !important;
}

.wrapperNegocio {
    margin-top: 0px;
    background-color: #607d8b;
    padding: 10px;
    color: #fff;
    box-shadow: 1px 1px 5px #888888;
}

.totalPedido {
    font-size: 1.4em;
    margin-top: 30px;
}

.bg-add-subproduct {
    background-color: #b3bec1a1 !important;
}

.btn-success:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: #6c757d;
    border-color: #6c757d;
    pointer-events: none;
}

table.table-bordered tr.row-invalid-supplier td {
    background-color: #fff9c4;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/PedidosProveedor/PedidoProveedorForm.vue